import { ReactNode, ButtonHTMLAttributes } from 'react';
import styles from './Button.module.css';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    variant?: 'primary' | 'secondary' | 'danger' | 'success';
    size?: 'sm' | 'md' | 'lg';
    fullWidth?: boolean;
    outlined?: boolean;
    rounded?: boolean;
    ghost?: boolean;
    iconLeft?: ReactNode;
    iconRight?: ReactNode;
    iconOnly?: ReactNode;
    loading?: boolean;
    children?: ReactNode;
}

export const Button = ({
    children,
    variant = 'primary',
    size = 'md',
    fullWidth = false,
    outlined = false,
    rounded = false,
    ghost = false,
    iconLeft,
    iconRight,
    iconOnly,
    loading = false,
    disabled,
    className = '',
    ...props
}: ButtonProps) => {
    const isDisabled = disabled || loading;

    const classes = `
        ${styles.btn} 
        ${ghost ? styles[`btn-${variant}-ghost`] : outlined ? styles[`btn-${variant}-outlined`] : styles[`btn-${variant}`]} 
        ${styles[`btn-${size}`]} 
        ${fullWidth ? styles['btn-full'] : ''} 
        ${rounded ? styles.rounded : ''}
        ${iconOnly ? styles.iconOnly : ''}
        ${className}
    `.trim().replace(/\s+/g, ' ');

    return (
        <button className={classes} disabled={isDisabled} {...props}>
            {iconOnly ? (
                iconOnly
            ) : loading ? (
                <>
                    <span className={styles.spinner} />
                    <span className={styles.loadingText}>{children}</span>
                </>
            ) : (
                <>
                    {iconLeft && <span className={styles.iconLeft}>{iconLeft}</span>}
                    {children}
                    {iconRight && <span className={styles.iconRight}>{iconRight}</span>}
                </>
            )}
        </button>
    );
};
